import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  Action,
  MutationRevokeMemberInvitationArgs,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  type UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getMemberInvitationsKey } from '../../utils/keys/authToken.keys.js'

export const useRevokeMemberInvitation = (options?: {
  useMutationOptions?: UseMutationOptions<
    Action,
    ClientError,
    MutationRevokeMemberInvitationArgs
  >
}) => {
  const { useMutationOptions } = options || {}
  const queryClient = useQueryClient()
  const { client } = useTribeClient()

  return useMutation<Action, ClientError, MutationRevokeMemberInvitationArgs>(
    variables =>
      client.mutation({
        name: 'revokeMemberInvitation',
        args: {
          variables,
          fields: 'all',
        },
      }),
    {
      ...useMutationOptions,
      onSettled: (data, error, variables, context) => {
        const memberInvitationsKey = getMemberInvitationsKey()
        queryClient.invalidateQueries(memberInvitationsKey)

        useMutationOptions?.onSettled?.(data, error, variables, context)
      },
    },
  )
}
